import React, { useEffect, useRef } from "react";
import style from "../../css/homepage/Testimonial.module.css";

const Testimonial = () => {
    const row1Ref = useRef(null);
    const row2Ref = useRef(null);
    const row1IntervalRef = useRef(null);
    const row2IntervalRef = useRef(null);

    useEffect(() => {
        const scrollRow = (row, intervalRef) => {
            if (!row) return;
            let speed = 1;
            const scroll = () => {
                if (row) {
                    row.scrollLeft += speed;
                    if (row.scrollLeft >= row.scrollWidth - row.clientWidth) {
                        row.scrollLeft = 0;
                    }
                }
            };
            intervalRef.current = setInterval(scroll, 30);
        };

        if (row1Ref.current) scrollRow(row1Ref.current, row1IntervalRef);
        if (row2Ref.current) scrollRow(row2Ref.current, row2IntervalRef);

        return () => {
            clearInterval(row1IntervalRef.current);
            clearInterval(row2IntervalRef.current);
        };
    }, []);

    const handleMouseEnter = (intervalRef) => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };

    const handleMouseLeave = (row, intervalRef) => {
        if (!intervalRef.current) {
            intervalRef.current = setInterval(() => {
                if (row) row.scrollLeft += 1;
            }, 30);
        }
    };

const reviews = [
  {
    name: "Kunal Sharma",
    rating: 5,
    description: "SwingAlgo ke swing setups ne meri portfolio ki overall returns ko double kar diya. Bohot hi structured aur simple explanation hai."
  },
  {
    name: "Megha Kapoor",
    rating: 5,
    description: "Main totally beginner thi, lekin SwingAlgo ne trading ka fear khatam kar diya. Strategies itni practical hain ki loss control mein aaya."
  },
  {
    name: "Ajay Nair",
    rating: 4,
    description: "SwingAlgo ka IPO strategy section bohot kamaal ka hai. Clear guidance milta hai."
  },
  {
    name: "Ritika Rathi",
    rating: 5,
    description: "Inka AI chatbot se doubt clear karna bada easy ho gaya hai. Real-time response aur logical reasoning bhi milta hai!"
  },
  {
    name: "Tushar Bhonsle",
    rating: 5,
    description: "Main part-time trader hoon, aur SwingAlgo se consistent profit ban rahe hain."
  },
  {
    name: "Sana Shaikh",
    rating: 5,
    description: "Jo log full-time job karte hain, unke liye SwingAlgo ek blessing hai. Simple swing setups follow karo and relax."
  },
  {
    name: "Dhruv Pandey",
    rating: 4,
    description: "Mujhe sabse zyada pasand aayi inki rocket base strategy. Fast moving trades ke liye perfect hai."
  },
  {
    name: "Sarthak Batra",
    rating: 5,
    description: "SwingAlgo ka stock screener AI-based hai, jisme exact fundamental aur technical dono milte hain — pure gold!"
  },
  {
    name: "Nikita Verma",
    rating: 5,
    description: "I love how easy SwingAlgo makes the complex data understandable for retail traders like me!"
  },
  {
    name: "Imran Qureshi",
    rating: 4,
    description: "Inka chat support super responsive hai. Koi bhi doubt ho toh 5 minute mein reply mil jaata hai."
  },
  {
    name: "Anjali Deshmukh",
    rating: 5,
    description: "SwingAlgo ne mujhe FOMO se bachaya. Ab main sirf setup based trades karta hoon. Peace of mind!"
  },
  {
    name: "Rohit Sinha",
    rating: 5,
    description: "Unke AI tools help you filter stocks fast. Mere liye time bach gaya aur accuracy bhi improve hua!"
  },
  {
    name: "Mitali Agrawal",
    rating: 4,
    description: "Agar videos aur bhi interactive hote toh aur maza aata. Lekin content is super valuable."
  },
  {
    name: "Vikram Chauhan",
    rating: 5,
    description: "SwingAlgo ke saath trading mera hobby se profession ban gaya hai. Hats off to the entire team!"
  },
  {
    name: "Sneha Narang",
    rating: 5,
    description: "SwingAlgo’s risk management lessons are underrated! Capital protect rehna bhi ek art hai, yahi yahan sikha."
  },
  {
    name: "Shruti Dey",
    rating: 5,
    description: "As a woman trader, I feel comfortable with their clear instructions and non-technical explanations. Thank you SwingAlgo!"
  },
  {
    name: "Manoj Patil",
    rating: 5,
    description: "SwingAlgo ka IPO success tracker ne meri planning easy bana di. Bahut smart feature hai!"
  },
  {
    name: "Aakash Tiwari",
    rating: 5,
    description: "Main other Telegram signals bhi follow karta hoon, lekin SwingAlgo wale way ahead hain in quality aur discipline."
  },
  {
    name: "Rina Joshi",
    rating: 5,
    description: "Fundamental details itne organized hain, jaise ek research analyst ka note ho. Kya baat hai!"
  },
  {
    name: "Amit Dugar",
    rating: 5,
    description: "Real-time market , fundamental and learning. All from one platform — SwingAlgo!"
  },
  {
    name: "Aaliya Khan",
    rating: 5,
    description: "Pichhle 3 mahine mein 7 trades liye SwingAlgo ki learning se. 6 profitable nikle. I’m super happy."
  },
  {
    name: "Karthik Raman",
    rating: 4,
    description: "Agar app version hota to aur convenient hota. But web experience is still excellent."
  },
  {
    name: "Ritu Rawat",
    rating: 5,
    description: "Itna organized learning platform maine pehli baar dekha. Clarity aur confidence dono milta hai."
  },
  {
    name: "Jatin Vora",
    rating: 5,
    description: "IPO mein loss ho raha tha bar bar, ab SwingAlgo ke saath proper research pe invest karta hoon. Results amazing!"
  },
  {
    name: "Farhan Sheikh",
    rating: 5,
    description: "Rocket base se main scalping bhi kar raha hoon. Setup bhale swing ka ho, lekin exit scalping level pe bhi milta hai."
  },
  {
    name: "Nidhi Jaiswal",
    rating: 5,
    description: "Kya analysis hai yaar! Kab buy karna hai aur kab sell, dono cheeze itni clearly explain hoti hain."
  },
  {
    name: "Suraj Nambiar",
    rating: 5,
    description: "SwingAlgo = Confidence + Clarity. I don’t trade without checking their levels now."
  },
  {
    name: "Shanaya Mehta",
    rating: 5,
    description: "Pehele emotions mein trade karti thi, ab setup based. Mindset completely change kar diya SwingAlgo ne."
  },
  {
    name: "Tejaswini Pillai",
    rating: 4,
    description: "I learned more in 1 week from SwingAlgo than in 3 months of watching YouTube videos!"
  },
  {
    name: "Dev Malhotra",
    rating: 5,
    description: "Bina indicators ke bhi yahan ke logic samajh aa jata hai. No-nonsense learning!"
  },
  {
    name: "Pranav Goel",
    rating: 5,
    description: "SwingAlgo ne sikhaya ki loss kaise kam kare aur profit kaise hold kare — that's real power."
  },
  {
    name: "Rachna Gupta",
    rating: 5,
    description: "Market updates ke sath sath trading psychology pe bhi kaam karte hain yeh log. Mujhe bohot help hua."
  },
  {
    name: "Yusuf Ahmed",
    rating: 4,
    description: "Fundamentals + technicals = perfect blend. Data ka visualization aur bhi improve ho sakta hai."
  },
  {
    name: "Mahima Srivastava",
    rating: 5,
    description: "Mujhe bas inka ek swing setup milta hai aur main usi se kaafi safe returns kama leti hoon."
  },
  {
    name: "Suresh Iyer",
    rating: 5,
    description: "Main 55 years ka hoon, lekin SwingAlgo ke easy approach ne mujhe bhi trading sikha diya."
  },
  {
    name: "Karishma Bhagat",
    rating: 5,
    description: "SwingAlgo ka dashboard simple aur user-friendly hai. Stock ki full health report ek hi jagah milti hai."
  },
  {
    name: "Ravindra Prasad",
    rating: 5,
    description: "Real time alerts + learning bhi milta hai. Life easy bana di trading ki!"
  },
  {
    name: "Rehaan Lala",
    rating: 5,
    description: "Best platform for anyone serious about earning from market. SwingAlgo ne confidence diya."
  },
  {
    name: "Bhavna Walia",
    rating: 5,
    description: "Kisi bhi company ka complete report chahiye — toh yahan milta hai. Time bach gaya mera!"
  },
  {
    name: "Siddhi Jain",
    rating: 5,
    description: "SwingAlgo ka best feature — live market logic ke sath explanation. Aise koi nahi karta."
  },
  {
    name: "Kavish Mehta",
    rating: 5,
    description: "Ek genuine trading partner chahiye toh SwingAlgo best hai. Paisa bhi bacha aur seekhne mila."
  },
  {
    name: "Kiran Tiwari",
    rating: 4,
    description: "All good, just waiting for mobile app launch. That will be super helpful."
  },
  {
    name: "Gaurav Dube",
    rating: 5,
    description: "Thanks SwingAlgo! 1st time I’m trading without fear. Ab samajh aata hai market!"
  }
];



    return (
        <>
        <div className={style.testimonia_container_fluid}>

            <div className={style.testimonial_container}>
                <div
                    className={style.testimonial_row}
                    ref={row1Ref}
                    onMouseEnter={() => handleMouseEnter(row1IntervalRef)}
                    onMouseLeave={() => handleMouseLeave(row1Ref.current, row1IntervalRef)}
                    >
                    {reviews.slice(0, 100).map((review, index) => (
                        <div key={index} className={style.testimonial_wrapper}>
                            <h3 className={style.testimonial_title}>{review.name}</h3>
                            <p className={style.testimonial_rating}>{'⭐'.repeat(review.rating)}</p>
                            <p className={style.testimonial_description}>{review.description}</p>
                        </div>
                    ))}
                </div>
            </div>
            <div className={style.testimonial_container}>
                <div
                    className={style.testimonial_row}
                    ref={row2Ref}
                    onMouseEnter={() => handleMouseEnter(row2IntervalRef)}
                    onMouseLeave={() => handleMouseLeave(row2Ref.current, row2IntervalRef)}
                    >
                    {reviews.slice(10, 100).map((review, index) => (
                        <div key={index} className={style.testimonial_wrapper}>
                            <h3 className={style.testimonial_title}>{review.name}</h3>
                            <p className={style.testimonial_rating}>{'⭐'.repeat(review.rating)}</p>
                            <p className={style.testimonial_description}>{review.description}</p>
                        </div>
                    ))}
                </div>
            </div>
                    </div>
        </>
    );
};

export default React.memo(Testimonial);
